import React from 'react';
import visioncamImage from '../../Assets/visioncam.jpg';
import '../../styles/layout/comingSoon.scss';

const Visioncam = () => {
  return (
    <div className="coming-soon-container">
      <div className="coming-soon-content" style={{ maxWidth: 'fit-content' }}>
        <img 
          src={visioncamImage} 
          alt="VisionCam coming soon" 
        />
      </div>
    </div>
  );
};

export default Visioncam; 